import React from 'react'
import {useState, useContext, useEffect} from 'react'
import {useQuery} from 'react-query'
import {FeedbackContext} from '../../../../Components/Context/FeedbackContext'
import {Loading} from '../../../../Components/Loading/Loading'
import {ErrorConnection} from '../../../../Components/Error/Error'
import {Spinner} from 'react-bootstrap'
import * as Api from '../../../../api/Api'
import {useGetToken} from '../../../../Hooks/CustomHooks'
import * as Utilities from '../../../../Components/Utils/Utils'
import $ from 'jquery'
import {Helmet} from 'react-helmet'
import '../mapplic.css'
import {BlockPicker} from 'react-color'
import Modal from 'react-bootstrap/Modal'

function VistaGeneral_rpteCierre({unidadEconomica, tipoReporte}) {
  const [mapplicObj, setMapplicObj] = useState(null)
  const token = useGetToken()

  const listColor = ['#87c141', '#f4e21a', '#e74157']

  const {feedbackContext, setFeedbackContext} = useContext(FeedbackContext)
  let {data, isLoading, isError, error, isFetching} = useQuery(
    [
      'MapaCalorVistaGeneral_rpteCierre',
      {
        unidadEconomica: unidadEconomica.value,
      },
    ],
    async () =>
      await Api.MapaCalorVistaGeneral_ReporteCierre({
        unidadEconomicaId: unidadEconomica.value,
      }),
    {
      enabled: true,
    }
  )

  useEffect(() => {
    if (data) {
      if (data.data === null) {
        //setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
      } else {
        setJsonMapFinalwithSettings(data.data.dataMapa, data.data.dataAux.cierres)
      }
    }
  }, [data])

  let coordenadasTemp = []
  document.addEventListener(
    'keyup',
    (e) => {
      if (e.altKey && e.shiftKey && String.fromCharCode(e.keyCode) == 'C') {
        console.log(coordenadasTemp)
      }
    },
    false
  )

  function setJsonMapFinalwithSettings(jsonResponseFromServer, cierres) {
    const settings = {
      mapwidth: '1300',
      mapheight: '1000',
      defaultstyle: 'normal',
      styles: [],
      groups: [],
    }

    cierres.forEach(function (currentValue, index, array) {
      settings.styles.push({
        class: 'statusClass' + (index + 1),
        base: {
          fill: listColor[index],
          'fill-opacity': '0.4',
        },
        hover: {
          'fill-opacity': '0.8',
        },
        active: {
          fill: 'green',
          'fill-opacity': '1',
        },
      })
      settings.groups.push({
        id: 'statusCategory' + (index + 1),
        title: currentValue,
        color: listColor[index],
        legend: 'true',
        style: 'statusClass' + (index + 1),
      })
    })

    let data = jsonResponseFromServer

    data.levels.forEach(function (element, index1, array) {
      if (parseInt(element.id) < 0) element['title'] = 'Sótano ' + Math.abs(parseInt(element.id))
      element['map'] =
        '/../mapas/' +
        unidadEconomica.label.toLowerCase().replace(/\s/g, '') +
        '/piso_' +
        element.id +
        '.svg'

      element.locations.forEach(function (elementLocation, index2, array) {
        elementLocation['pin'] = 'hidden'
        elementLocation['titleModal'] = elementLocation['title']
        let indxRango = 0
        for (indxRango; indxRango < cierres.length; indxRango++) {
          if (cierres[indxRango] == elementLocation.rango) {
            elementLocation['category'] = 'statusCategory' + (indxRango + 1)
            elementLocation['style'] = 'statusCategory' + (indxRango + 1)
            elementLocation['title'] =
              elementLocation['title'].length > 10
                ? elementLocation['title'].slice(0, 10) + '...'
                : elementLocation['title']
            break
          }
        }
        elementLocation['description'] = ''
      })
    })

    let returnedTarget = Object.assign(data, settings)

    let mapplicObjTemp = {
      source: returnedTarget,
      height: 'auto',
      // minimap: true,
      lightbox: false,
      sidebar: false,
      hovertip: true,
      maxscale: 10,
      developer: false,
      highlight: true,
      zoom: true,
      mousewheel: true,
      closezoomout: true,
      thumbholder: true,
    }

    //#region Funcion Colorea Bloque
    setTimeout(function () {
      // $(".mapplic-level-switcher :button").click(function () {
      //     setColorLocatarios();
      // });

      $('.mapplic-pin').each(function (index) {
        $(this).css('background-color', 'white')
      })
    }, 1000)

    let encontrados = 0
    let locationNull = false
    function setColorLocatarios() {
      for (let indexLevel = 0; indexLevel < data.levels.length; indexLevel++) {
        if (locationNull && encontrados < 3) break
        const element = data.levels[indexLevel]

        for (let indexLocation = 0; indexLocation < element.locations.length; indexLocation++) {
          if (locationNull && encontrados < 3) break
          const elementLocation = element.locations[indexLocation]

          locationNull = $('#' + elementLocation.id).length == 0
          if (!locationNull) encontrados++
          else console.log(elementLocation.id, $('#' + elementLocation.id).length)

          let styleTemp = ``
          let indxColor = 0
          for (indxColor; indxColor < cierres.length; indxColor++) {
            if (cierres[indxColor] == elementLocation.rango) {
              styleTemp = `background-color: ${listColor[indxColor]} !important;fill: ${listColor[indxColor]} !important;`
              break
            }
          }

          $('#' + elementLocation.id).attr('style', styleTemp)
          $('#' + elementLocation.id).attr('data-toggle', 'tooltip')
          $('#' + elementLocation.id).attr('data-placement', 'Tooltip on top')
          $('#' + elementLocation.id).attr('data-bs-html', 'true')

          $('#' + elementLocation.id).attr(
            'title',
            elementLocation.id + ' : ' + elementLocation.titleModal
          )

          $('#' + elementLocation.id).on('click touchstart', function () {
            let x = $('.mapplic-coordinates-x').html()
            let y = $('.mapplic-coordinates-y').html()
            let elementTemp = {id: elementLocation.id, x: x, y: y}

            let found = coordenadasTemp.find(function (element) {
              return element.id == elementLocation.id
            })

            if (found == null) coordenadasTemp.push(elementTemp)
          })
        }
      }

      if (locationNull)
        setTimeout(function () {
          locationNull = false
          setColorLocatarios()
        }, 1500)
    }

    setTimeout(function () {
      setColorLocatarios()
    }, 1500)

    //#endregion

    setMapplicObj(mapplicObjTemp)
  }

  if (isLoading) return <Loading />
  if (isError) return <ErrorConnection error={error} />
  return (
    <>
      {isFetching ? (
        <Spinner animation='grow' variant='secondary' />
      ) : data?.data && data?.data?.dataMapa?.levels.length > 0 ? (
        <>
          <div className='application'>
            <Helmet>
              <script>
                {`
                                        if (` +
                  JSON.stringify(mapplicObj) +
                  ` != null) {
                                            $('#mapplic_container_all_in').mapplic(` +
                  JSON.stringify(mapplicObj) +
                  `);
                                             setTimeout(function () {
                                                 $('[data-toggle="tooltip"]').tooltip({ container: 'body' })
                                             }, 2000)
                                        }
                                    `}
              </script>
            </Helmet>
          </div>

          <div id='mapplic_container_all_in'></div>
        </>
      ) : (
        <div class='alert alert-warning' role='alert'>
          Actualmente no existen datos de ventas para este Mall.
        </div>
      )}
    </>
  )
}

export default VistaGeneral_rpteCierre
